// Translations
import landing from '../views/landing/translations/tr'

// Translation: Password change (Turkish)
export default Object.freeze({
	name: '',
	views: { landing }
})
